import type { UseEmojiPickerType } from '@platejs/emoji/react';

import { emojiSearchIcons } from './emoji-icons';

export type EmojiPickerSearchAndClearProps = Pick<
    UseEmojiPickerType,
    'clearSearch' | 'i18n' | 'searchValue'
>;

export function EmojiPickerSearchAndClear({
                                              clearSearch,
                                              i18n,
                                              searchValue,
                                          }: EmojiPickerSearchAndClearProps) {
    return (
        <>
            <div>
                {emojiSearchIcons.loupe}
            </div>
            {searchValue && (
                <button
                    onClick={clearSearch}
                    title={i18n.clear}
                    aria-label="Clear"
                    type="button"
                    style={{order: 3}}
                >
                    {emojiSearchIcons.delete}
                </button>
            )}
        </>
    );
}
